// procure
import request from "@/utils/request";

let ProcureApi = {
  /*列表*/
  indexList(data, errorback) {
    return request._post("/shop/product.procure/index", data, errorback);
  },
  /*新增*/ 
  addInfo(data, errorback) {
    return request._post("/shop/product.procure/addInfo", data, errorback);
  },
  /*删除*/ 
  delInfo(data, errorback) {
    return request._post("/shop/product.procure/delInfo", data, errorback);
  },
};

export default ProcureApi;



// WEBPACK FOOTER //
// ./src/api/procure.js